export const generateVersionsJSON = (versionJson = {}) => ({
  name: 'generate-versions-json',
  generateBundle() {
    (this as any).emitFile({
      type: 'asset',
      fileName: 'versions.json',
      source: JSON.stringify({ ...versionJson }),
    });
  },
});
